export default async function getContacts({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'contacts');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
